import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { Rokojori } from "../Rokojori";

export class SetCartItems
{
  static readonly type = new ElementType( "cart-num-items" );

  static async applyOnDocument()
  {
    let cart = Rokojori.$.assetManagerServer.assetsCart;

    await cart.sync();
    
    SetCartItems.type.forAllInDoc( e => this.applyOnElement( e ) );
  }

  static async applyOnElement( e:Element )
  {
   
    let cart = Rokojori.$.assetManagerServer.assetsCart;

    let visible = cart.cart.length > 0 || cart.wishlist.length > 0;

    //console.log( "FIND CART NUM ITEMS:", e, visible );

    ClassFlag.visible.setAs( e, visible );
  }
}